import { createSlice } from "@reduxjs/toolkit";
import { BROWSE_REPORT } from "./constants";

export const smsSlice = createSlice({
  name: BROWSE_REPORT,
  initialState: {
    daily_report_sim_chart_data: []
  },
  reducers: {
    getSimChartInit(state) {
      state.daily_report_sim_chart_data = [];
      return state;
    },
    getSimChartSucceed(state, action) {
      state.daily_report_sim_chart_data = action.payload.data;
      return state;
    },
    getSimChartFailed(state) {
      state.daily_report_sim_chart_data = [];
      return state;
    }
  }
});

export const smsReportActions = smsSlice.actions;
export const smsReportReducer = smsSlice.reducer;
